import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const ENTITY_ID = 0;

const actions = {
    toggleResidentAccountAccess: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residents/:id/access`
    },
    getUrlToSignInAsResident: {
        url: `${BASE_PATH_API}/residents/userLeases/:userLeaseId/signIn`,
        method: 'GET'
    },
    resetResidentPassword: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residents/userLeases/:userLeaseId/password`
    },
    updateResidentAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residents/userLeases/:userLeaseId/account`
    },
    setResidentSitePrimaryColor: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residentSite/primaryColor`
    },
    getResidentSitePrimaryColor: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentSite/primaryColor`
    },
    setResidentSiteLogoColors: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residentSite/logoColors`
    },
    getResidentPortalSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/${ENTITY_ID}/resident`
    },
    updateResidentPortalSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/resident`
    },
    getStaffForRequestDefaultAssignee: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentSite/requests/staff`
    },
    getResidentSiteUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentSiteUsers`,
        params: {
            '$count': true
        }
    },
    getResidentSiteUsersV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentSiteUsersV2`,
        params: {
            '$count': true
        }
    },
    getResidentWebsiteAccountsToCreate: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentSiteUsers/websiteAccounts`,
        params: {
            '$count': true
        }
    },
    createResidentWebsiteAccounts: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentSiteUsers/websiteAccounts`
    },
    resetResidentsPasswordInBulk: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentSiteUsers/resetPassword`
    },
    blockResidentAccountAccessInBulk: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentSiteUsers/blockAccess`
    },
    getOnlinePreLeasePaymentSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/resident/preLeaseOnlinePaymentSettings`
    },
    updateOnlinePreLeasePaymentSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/resident/preLeaseOnlinePaymentSettings`
    },
    getACHRefundSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/resident/achRefundSettings`
    },
    updateACHRefundSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/resident/achRefundSettings`
    }
};

export function ResidentsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getResidentSiteUsersExportUrl = function getResidentSiteUsersExportUrl(params) {
        return `${BASE_PATH_API}/residentSiteUsers/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
ResidentsApi.$inject = [
    '$httpParamSerializer'
];
